import React, { useEffect, useState, } from 'react'
import { Link, } from 'react-router-dom'
import $ from 'jquery';
import Swal from 'sweetalert2';
import axios from 'axios';

import useAuth from '../../controllers/users/useAuth';
import {
    checkIfUserIsMaster, dataTableLanguaje, buttonProcessGet, responseGet, globalSettings, setBadgeStatusGeneric, styles, sendMessageCloseCurrentWindowAsync, separatorsNumbersSet,
    numberSet, awaitDelay, processEvaluateGet, languageObjGet, isUndNullEmp, LoadingSection, lodash
} from '../../helpers/settings'

import Menu from '../main/Menu'
import BankAccountAddEditDetails from './BankAccountAddEditDetails';
import { bankAccountModelGet } from '../../models/bankAccounts/bankAccount';
import BuildingHeader from '../buildings/BuildingHeader';
import { buildingsByUserGetAsync } from '../../controllers/apartments/apartmentUsers';
import { validationBankGetAsync, validationCoinGetAsync } from '../../helpers/validations';
import { GlobalFormats } from '../../classes/main/globalFormats';
import { buildingModelGet } from '../../models/buildings/building';
import { bankModelGet } from '../../models/banks/bank';
import { coinModelGet } from '../../models/coins/coin';

const { backend, } = globalSettings?.app;
const { icons, labels, messages, } = globalSettings;
const { html } = globalSettings?.react;
const { properties: dbProps, } = globalSettings?.collections;
const { operators: dbOpera, } = globalSettings?.react?.firebase;

const currentMethod = 'BankAccounts';

const neutralValue = 0.00;
const neutralValueStr = separatorsNumbersSet({
    number: neutralValue,
    withDecimals: true,
    consoleLogErrorShow: true,
    subMethod: currentMethod,
})?.result;

export default function BankAccounts({
    languageObj = GlobalFormats?.class(languageObjGet({ subMethod: currentMethod, })?.result),
}) {
    //#region variables
    let result;
    let dataObj = {};
    let headerObj = {};
    const auth = useAuth();
    let swalProperties = {};
    //const history = useHistory();
    //const [showData, setShowData] = useState(false);
    const [processType, setProcessType] = useState(0);
    const [btnAddDisabled, setBtnAddDisabled] = useState(true);
    const [showLoading, setShowLoading] = useState({ building: true, bankAccounts: true, });
    const userRole = checkIfUserIsMaster({ email: auth?.user?.email || '', languageId: '', subMethod: '', })?.result;
    const [headerSectionValues, setHeaderSectionValues] = useState(
        {
            levelOne: {
                colOne: {},
                colTwo: {},
                colThree: {
                    label: labels?.balance?.[languageObj?.id],
                    value: neutralValueStr,
                    icon: icons?.moneyBillWave,
                    className: 'form-control bg-transparent text-black text-right',
                },
            }
        }
    );
    //#endregion variables

    //#region buildings
    const buildingsId = 'buildingsId';
    const [building, setBuilding] = useState(buildingModelGet({}));
    const [buildings, setBuildings] = useState([buildingModelGet({})]);
    //#endregion buildings

    //#region bank accounts
    const dtBankAccountsId = 'dtBankAccounts';
    //const btnBankAccountDeleteId = 'btnBankAccountDelete';
    const [bankAccount, setBankAccount] = useState(bankAccountModelGet({}));
    const [bankAccountShowModal, setBankAccountShowModal] = useState(false);
    const [dtBankAccountsRowIndex, setDtBankAccountsRowIndex] = useState(0);
    const [btnBankAccountsSyncDisabled, setBtnBankAccountsSyncDisabled] = useState(true);
    //#endregion bank accounts

    //#region banks
    let banksTwo = [];
    const [banks, setBanks] = useState([bankModelGet({})]);
    //#endregion banks

    //#region coins
    let coinsTwo = [];
    const [coins, setCoins] = useState([coinModelGet({})]);
    //#endregion coins

    //#region others
    const controls = {
        buttons: {
            // save: {
            //     id: 'btnAdd',
            //     className: 'btn btn-outline-warning mx-1',
            // },
            // back: {
            //     id: 'btnBack',
            //     className: '',
            // },
            // close: {
            //     id: 'btnClose',
            //     className: 'close btn-danger fas fa-window-close',
            // },
        },
        checkBox: {
            // remenberMe: {
            //     attributes: {
            //     },
            //     id: 'chkRemenberMe',
            // },
        },
        dataTables: {
            bankAccounst: {
                buttons: {
                    add: {
                        className: 'btn btn-sm btn-outline-success float-right',
                        id: 'btnDtBankAccountsIdAdd',
                    },
                },
                icons: {
                    add: {
                        id: 'iconDtBankAccountsIdAdd',
                        className: icons?.plusCircle,
                    },
                },
                inputs: {
                    search: {
                        id: `${dtBankAccountsId}_filter input`,
                        className: '',
                    },
                },
                selects: {
                    entries: {
                        id: `${dtBankAccountsId}_length select`,
                        className: '',
                    },
                },
                spinners: {
                    add: {
                        id: 'spDtBankAccountsIdAdd',
                        className: '',
                    },
                },
            },
        },
        icons: {
            // save: {
            //     id: 'icoSave',
            //     className: icons?.save,
            // },
            // back: {
            //     id: 'icoBack',
            //     className: icons?.arrowCircleLeft,
            // },
            // close: {
            //     id: 'icoClose',
            //     className: icons?.plusCircle,
            // },
        },
        inputs: {
            // user: {
            //     id: 'inputUser',
            //     className: 'form-control bg-transparent',
            // },
            // title: {
            //     id: 'inputTitle',
            //     className: 'form-control bg-transparent',
            // },
            // comment: {
            //     id: 'inputComment',
            //     className: 'form-control',
            // },
            // statusComment: {
            //     id: 'inputStatusComment',
            //     className: 'form-control bg-transparent text-black',
            // },
        },
        selects: {
            // apartment: {
            //     id: 'selApartmet',
            //     className: 'form-select',
            // },
            // title: {
            //     id: 'selTitle',
            //     className: 'form-select',
            // },
            // icon: {
            //     id: 'selIcon',
            //     className: 'form-select',
            // },
            // status: {
            //     id: 'selStatus',
            //     className: 'form-select',
            // },
        },
        spinners: {
            // save: {
            //     id: 'spSave',
            //     className: '',
            // },
            // back: {
            //     id: 'spBack',
            //     className: '',
            // },
        },
        urls: {
            // forgotYourPassword: {
            //     id: 'urlForgotYourPassword',
            //     className: 'btn-link',
            // },
            // reCaptchaPrivaciConditions: {
            //     id: 'urlReCaptchaPrivaciConditions',
            //     className: '',
            // },
            // userRegister: {
            //     id: 'urlRequestAccount',
            //     className: '',
            // },
            // registerStatus: {
            //     id: 'urlStatusRegister',
            //     className: '',
            // },
        },
    };
    //#endregion others

    //#region bank account (methods)
    const dataTableBankAccountsSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTableBankAccountsSetAsync';
        let response = responseGet();
        try {
            $(`#${dtBankAccountsId}`)?.DataTable({
                //buttons: ['excel', 'pdf', 'print', 'colvis',],
                columns: [
                    { title: labels?.bank?.[languageObj?.id], width: '25%', },
                    { title: labels?.number?.[languageObj?.id], width: '20%', },
                    { title: labels?.type?.[languageObj?.id], width: '15%', },
                    { title: labels?.condition?.[languageObj?.id], className: 'text-center', width: '15%', },
                    { title: labels?.currentBalance?.[languageObj?.id], className: 'text-right', width: '20%', },
                    { title: labels?.process?.[languageObj?.id], className: 'text-center', orderable: false, searchable: false, width: '5%', },
                ],
                data: [],
                destroy: true,
                language: dataTableLanguaje({ languageId: languageObj?.id, subMethod: currentMethod, }),
                order: [[0, 'desc'],],
                responsive: true,
                lengthChange: true,
                autoWidth: false,
                //}).buttons().container().appendTo(`#${dtBankAccountsId}_wrapper .col-md-6:eq(0)`);
            });
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const bankAccountsGetAsync = async ({
        e = {},
        processType_ = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'bankAccountsGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let dtRows = [];
            let isEditLocal = false;
            let isDeleteLocal = false;
            let bankLocal = bankModelGet({});
            let buildingLocal = buildingModelGet({});
            let buildingIdLocal = $(`#${buildingsId}`)?.val();
            let bankAccountsLocal = [bankAccountModelGet({})];
            //#endregion variables

            setShowLoading({ building: false, bankAccounts: true, });

            //#region dataTables clear
            response = await dataTablesClearAsync({
                bankAccouns: true,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return;
            }
            //#endregion dataTables clear

            //#region variables initialize
            headerSectionValues.levelOne.colThree.value = neutralValueStr;
            setHeaderSectionValues(headerSectionValues);

            setBuilding({});
            setBtnBankAccountsSyncDisabled(true);
            setProcessType(processType_ === 's' ? 0 : processType_);

            //#region old code
            // response = await buildingBalanceGetAsync({
            //     bankAccounts: [],
            //     buildingId: buildingIdLocal,
            //     subMethod: currentMethod,
            // });

            // if (!response?.isSuccess || response?.isWarning) {
            //     setShowLoading({ building: false, bankAccounts: false, });
            //     await sendMessageCloseCurrentWindowAsync({
            //         msgType: response?.msgType,
            //         msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
            //         closeWindow: false,
            //         urlGoTo: response?.urlGoTo,
            //         auth: auth,
            //         isLogout: false,
            //         languageId: languageObj?.id,
            //         subMethod: currentMethod,
            //     });
            //     return;
            // }
            //#endregion old code
            //#endregion variables initialize

            //#region bankAccounts get
            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                buildingLocal = buildings?.find(({ id }) => id === buildingIdLocal) || {};
                if (!isUndNullEmp({ data: buildingLocal?.id, subMethod: currentMethod, })?.result) {
                    setBuilding(buildingLocal);

                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                        },
                    };

                    dataObj = {
                        limit: 0,
                        ordersBy: [],
                        conditionals: [
                            { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: buildingIdLocal, },
                        ],
                        buildingId: buildingIdLocal,
                        languageId: languageObj?.id,
                        url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBankAccounts}/`,
                    };

                    result = await axios?.post(
                        dataObj?.url,
                        dataObj,
                        headerObj,
                    );

                    response = result?.data || {};

                    if (!response?.isSuccess || response?.isWarning) {
                        setShowLoading({ building: false, bankAccounts: false, });
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    bankAccountsLocal = response?.result || [];

                    if (!isUndNullEmp({ data: bankAccountsLocal, subMethod: currentMethod, })?.result && bankAccountsLocal?.length > 0) {
                        //#region banks get
                        response = await banksGetAsync({
                            buildingId: buildingIdLocal,
                            subMethod: currentMethod,
                        });

                        if (!response?.isSuccess || response?.isWarning) {
                            setShowLoading({ building: false, bankAccounts: false, });
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion banks get

                        bankAccountsLocal?.forEach((detail) => {
                            //#region variables
                            bankLocal = banksTwo?.find(({ id }) => id === detail?.bankId) || {};
                            //bankDescriptionLocal = bankLocal?.description;
                            dataObj = {
                                description: bankLocal?.description,
                                number: detail?.number,
                                type: detail?.type === 'S' ?
                                    labels?.savings?.[languageObj?.id] :
                                    detail?.type === 'C' ?
                                        labels?.current?.[languageObj?.id] :
                                        '',
                                status: setBadgeStatusGeneric({
                                    type: detail?.inactive ? 1 : 0,
                                    value: detail?.inactive ?
                                        labels?.inactive?.[languageObj?.id] :
                                        labels?.active?.[languageObj?.id],
                                    subMethod: currentMethod,
                                }),
                                currentBalance: separatorsNumbersSet({
                                    number: numberSet({
                                        number: detail?.currentBalance,
                                        type: 'd',
                                        languageId: languageObj?.id,
                                        subMethod: currentMethod,
                                    })?.result,
                                    withDecimals: true,
                                    consoleLogErrorShow: true,
                                    subMethod: currentMethod,
                                })?.result,
                                processButtons: [
                                    {
                                        isVisible: true,
                                        showDivider: false,
                                        label: labels?.movements?.[languageObj?.id],
                                        isEnabled: true,
                                        methodName: backend?.methods?.movements,
                                        icon: icons?.chartLine,
                                    },
                                    {
                                        isVisible: true,
                                        showDivider: true,
                                        label: labels?.delete?.[languageObj?.id],
                                        isEnabled: processEvaluateGet({
                                            object: detail,
                                            property: labels?.process?.en?.toLowerCase(),
                                            process: labels?.delete?.en?.toLowerCase(),
                                            subMethod: currentMethod,
                                        })?.result,
                                        methodName: backend?.methods?.delete,
                                        icon: icons?.trash,
                                    },
                                ],
                            }
                            //#endregion variables

                            //#region methods
                            dtRows.push([
                                //#region old code
                                // bankDescriptionLocal,
                                // detail?.number,
                                // (detail?.type === 'S' ? labels?.savings?.[languageObj?.id] : (detail?.type === 'C' ? labels?.current?.[languageObj?.id] : '')),
                                // setBadgeStatusGeneric((detail?.inactive ? 1 : 0), (detail?.inactive ? labels?.inactive?.[languageObj?.id] : labels?.active?.[languageObj?.id])),
                                // separatorsNumbersSet(numberSet(detail?.currentBalance, 'd').result, true).result,
                                // //`${numberSet(detail?.currentBalance, 'd').result}`,
                                //#endregion old code
                                dataObj?.description,
                                dataObj?.number,
                                dataObj?.type,
                                dataObj?.status,
                                dataObj?.currentBalance,
                                buttonProcessGet({
                                    id: detail?.id,
                                    description: dataObj?.description,
                                    showDetails: true,
                                    labelDetails: labels?.detail?.[languageObj?.id],
                                    enabledDetails: true,
                                    showEdit: true,
                                    labelEdit: labels?.edit?.[languageObj?.id],
                                    enabledEdit: processEvaluateGet({
                                        object: detail,
                                        property: labels?.process?.en?.toLowerCase(),
                                        process: labels?.edit?.en?.toLowerCase(),
                                        subMethod: currentMethod,
                                    })?.result,
                                    showDelete: false,
                                    labelDelete: labels?.delete?.[languageObj?.id],
                                    enabledDelete: false,
                                    processButtons: dataObj?.processButtons
                                })?.result,
                            ]);
                            //#endregion methods
                        });

                        //#region buildingBalance
                        response = await buildingBalanceGetAsync({
                            bankAccounts: bankAccountsLocal,
                            buildingId: buildingIdLocal,
                            subMethod: currentMethod,
                        });

                        if (!response?.isSuccess || response?.isWarning) {
                            setShowLoading({ building: false, bankAccounts: false, });
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion buildingBalance
                    }
                    setBtnBankAccountsSyncDisabled(false);

                    //#region btnAddDisabled set
                    isEditLocal = processEvaluateGet({
                        object: buildingLocal,
                        property: labels?.process?.en?.toLowerCase(),
                        process: labels?.edit?.en?.toLowerCase(),
                        subMethod: currentMethod,
                    })?.result;

                    isDeleteLocal = isEditLocal;
                    setBtnAddDisabled(!(isEditLocal && isDeleteLocal));
                    //#endregion btnAddDisabled set
                }
            }
            //#endregion bankAccounts get

            //#region data in dataTable set
            $(`#${dtBankAccountsId}`)?.DataTable()?.rows?.add(dtRows)?.draw();
            //#endregion data in dataTable set

            setShowLoading({ building: false, bankAccounts: false, });
        } catch (ex) {
            setShowLoading({ building: false, bankAccounts: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const bankAccountsAddEditDetailsGetAsync = async ({
        e = {},
        id = '',
        description = '',
        rowIndex = 0,
        processType_ = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'bankAccountsAddEditDetailsGetAsync';
        let response = responseGet();
        try {
            if (!isUndNullEmp({ data: e, subMethod: currentMethod, })?.result) {
                e?.preventDefault();
            }

            //#region variables
            let bankAccountLocal = bankAccountModelGet({});
            let buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#endregion variables

            if (processType_ === 0) {
                controlsStatusSet({ processType: 1, subMethod: currentMethod, });
            } else {
                setShowLoading({ building: false, bankAccounts: true, });
            }

            //#region variables initialize
            setBankAccount({});
            setProcessType(processType_);
            //#endregion variables initialize

            if (!isUndNullEmp({ data: buildingIdLocal, subMethod: currentMethod, })?.result) {
                //#region coins get
                response = await coinsGetAsync({
                    buildingId: buildingIdLocal,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    if (processType_ === 0) {
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    } else {
                        setShowLoading({ building: false, bankAccounts: false, });
                    }
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion coins get

                //#region banks get
                response = await banksGetAsync({
                    buildingId: buildingIdLocal,
                    subMethod: currentMethod,
                });

                if (!response?.isSuccess || response?.isWarning) {
                    if (processType_ === 0) {
                        controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                    } else {
                        setShowLoading({ building: false, bankAccounts: false, });
                    }
                    await sendMessageCloseCurrentWindowAsync({
                        msgType: response?.msgType,
                        msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                        closeWindow: false,
                        urlGoTo: response?.urlGoTo,
                        auth: auth,
                        isLogout: false,
                        languageId: languageObj?.id,
                        subMethod: currentMethod,
                    });
                    return;
                }
                //#endregion banks get

                //#region get / set bank account
                if (processType_ === 0) {
                    setBankAccount(
                        bankAccountModelGet({
                            buildingId: buildingIdLocal,
                            bankId: '',
                            coinId: '',
                            userId: auth?.user?.uid,
                        })
                    );
                } else {
                    headerObj = {
                        headers: {
                            authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                            languageId: languageObj?.id,
                        },
                        url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBankAccounts}/${id}`,
                    };

                    result = await axios?.get(
                        headerObj?.url,
                        headerObj,
                    );

                    response = result?.data || {};

                    if (!response?.isSuccess || response?.isWarning) {
                        if (processType_ === 0) {
                            controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                        } else {
                            setShowLoading({ building: false, bankAccounts: false, });
                        }
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                        return;
                    }

                    bankAccountLocal = response?.result?.bankAccount || {};
                    setBankAccount(bankAccountLocal);
                }
                //#endregion get / set bank accounts
            } else {
                if (processType_ === 0) {
                    controlsStatusSet({ processType: 0, subMethod: currentMethod, });
                } else {
                    setShowLoading({ building: false, bankAccounts: false, });
                }
                await sendMessageCloseCurrentWindowAsync({
                    msgType: 1,
                    msgText: messages?.youMustSelectBuilding?.[languageObj?.id],
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            //#region data set
            setProcessType(processType_);
            setDtBankAccountsRowIndex(rowIndex);
            //#endregion data set

            if (processType_ === 0) {
                await awaitDelay({ delayTimer: globalSettings?.timers?.threeNanoSeconds, });
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else {
                setShowLoading({ building: false, bankAccounts: false, });
            }

            setBankAccountShowModal(true);
        } catch (ex) {
            if (processType_ === 0) {
                controlsStatusSet({ processType: 0, subMethod: currentMethod, });
            } else {
                setShowLoading({ building: false, bankAccounts: false, });
            }
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    //#region old code
    // const localBankAccountDeleteGet = (id = '', description = '', rowIndex = 0) => {
    //     let response = responseGet();
    //     try {

    //         sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //         setDtBankAccountsRowIndex(rowIndex);
    //         setBankAccount({});
    //         setBankAccount({ id, description, });
    //         $(`#${btnBankAccountDeleteId}`)?.trigger('click');
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localBankAccountDeleteGet<br/>`;
    //         response.msgText += `Error: <br/>${ex?.message}`;
    //         sendMessage(response.msgType, response.msgText, 0, true, false, null, '');
    //     }
    // }
    //#endregion old code

    //#region old code
    // const localBankAccountDeleteGetAsync = async (e = {}) => {
    //     let response = responseGet();
    //     try {
    //         e?.preventDefault();

    //         //#region variables

    //         let localMsgText = '';
    //         let localBankAccount = {}
    //         let localBankAccountType = '';

    //         //#endregion variables

    //         sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

    //         //#region data get (bank account)

    //         headerObj = {
    //             headers: {
    //                 authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
    //             },
    //         };
    //         //result = await axios?.get(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlBankAccounts}/${bankAccount.id}`, headerObj);
    //         result = await axios?.get(`${backend?.url}${backend?.urlApiV1}${backend?.urlBankAccounts}/${bankAccount.id}`, headerObj);
    //         response = result.data;

    //         if (!response?.isSuccess || response?.isWarning) {
    //             await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //             return;
    //         }

    //         localBankAccount = response.result;

    //         //#endregion data get (bank account)

    //         //#region show message

    //         localBankAccountType = localBankAccount.type === 'C' ?
    //             labels?.current?.[languageObj?.id] : localBankAccount.type === 'S' ?
    //                 labels?.savings?.[languageObj?.id] : labels?.undefined?.[languageObj?.id];

    //         localMsgText = `${labels?.bankAccount?.[languageObj?.id]}<br/>`;
    //         localMsgText += `${labels?.type?.[languageObj?.id]}: <b>${localBankAccountType}</b><br/>`;
    //         localMsgText += `${labels?.number?.[languageObj?.id]}: <b>${localBankAccount.number}</b><br/>`;
    //         localMsgText += `${labels?.bank?.[languageObj?.id]}: <b>${bankAccount.description}</b><br/>`;
    //         localMsgText += `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`;

    //         swalProperties = {
    //             icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
    //             title: messages?.areYouSureDeleteThis?.[languageObj?.id],
    //             html: localMsgText,
    //             timer: null,
    //             confirmButtonColor: globalSettings?.colors?.warningColorExp,
    //             confirmButtonText: labels?.yes?.[languageObj?.id],
    //             showCancelButton: true,
    //             cancelButtonColor: globalSettings?.colors?.successColorExp,
    //             cancelButtonText: labels?.no?.[languageObj?.id],
    //             didOpen: () => {
    //                 Swal.hideLoading();
    //             },
    //         };

    //         const { isConfirmed, } = await Swal.fire(swalProperties);

    //         //#endregion show message

    //         //#region delete data (bank account)

    //         if (isConfirmed) {
    //             bankAccountDeleteAsync();
    //         }

    //         //#endregion delete data (bank account)
    //     } catch (ex) {
    //         response.msgType = -1;
    //         response.isSuccess = false;
    //         response.msgText = `Method: localBankAccountDeleteGetAsync<br/>`;
    //         response.msgText += `Error: ${ex?.message}`;
    //         await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
    //     }
    // }
    //#endregion old code

    const bankAccountDeleteAsync = async ({
        id = '',
        description = '',
        rowIndex = 0,
        processType = 0,
        subMethod = '',
    }) => {
        const currentMethod = 'bankAccountDeleteAsync';
        let response = responseGet();
        try {
            //#region variables
            let bankAccountLocal = bankAccountModelGet({});
            const buildingIdLocal = $(`#${buildingsId}`)?.val();
            //#endregion variables

            //#region old code
            // sendMessage(2, messages?.processing?.[languageObj?.id], globalSettings?.timers?.thirtySeconds, false, true, null, '');

            // //#region delete collection bank account

            // headerObj = {
            //     headers: {
            //         authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
            //     },
            // };

            // //result = await axios.delete(`${backend?.urlDev}${backend?.urlApiV1}${backend?.urlBankAccounts}/${bankAccount.id}`, headerObj);
            // result = await axios.delete(`${backend?.url}${backend?.urlApiV1}${backend?.urlBankAccounts}/${bankAccount.id}`, headerObj);
            // response = result.data;

            // if (!response?.isSuccess || response?.isWarning) {
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }

            // bankAccountLocal = response.result;

            // //#endregion delete collection bank account

            // //#region delete collection bank account (dataTable)

            // $(`#${dtBankAccountsId}`)?.DataTable()?.row(dtBankAccountsRowIndex)?.remove()?.draw(true);

            // //#endregion delete collection bank account (dataTable)

            // //#region Calulate building balance

            // //#region old code

            // //response = await buildingBalanceGetAsync(null, localBankAccount.buildingId);

            // //#endregion old code

            // response = await buildingBalanceGetAsync(
            //     null,
            //     !isUndefined(bankAccountLocal) && !isNull(bankAccountLocal) && !isEmpty(bankAccountLocal) ?
            //         bankAccountLocal.buildingId :
            //         building.id,
            //     'bankAccountDeleteAsync'
            // );
            // if (!response?.isSuccess || response?.isWarning) {
            //     await sendMessageCloseCurrentWindowAsync(response.msgType, replaceMessages(0, response.msgText).result, false, response.urlGoTo, auth, false);
            //     return;
            // }

            // //#endregion Calulate building balance

            // //#region data set

            // setBankAccount({});
            // setDtBankAccountsRowIndex(0);

            // //#endregion data set

            // sendMessage(0, messages?.processesCompletedSuccessfully?.[languageObj?.id], 0, true, false, null, '');
            //#endregion old code

            setShowLoading({ building: false, bankAccounts: true, });

            //#region bankAccount get
            headerObj = {
                headers: {
                    authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    languageId: languageObj?.id,
                },
                url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBankAccounts}/${id}`,
            };

            result = await axios?.get(
                headerObj?.url,
                headerObj,
            );

            response = result?.data || {};

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, bankAccounts: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            bankAccountLocal = response?.result?.bankAccount || {};
            //#endregion bankAccount get

            setShowLoading({ building: false, bankAccounts: false, });

            //#region show message
            let msgTextObj = {
                one: `${labels?.bankAccount?.[languageObj?.id]}<br/>`,
                two: `${labels?.type?.[languageObj?.id]}: <b>${bankAccountLocal?.type === 'C' ?
                    labels?.current?.[languageObj?.id] :
                    bankAccountLocal?.type === 'S' ?
                        labels?.savings?.[languageObj?.id] :
                        labels?.undefined?.[languageObj?.id]}</b><br/>`,
                three: `${labels?.number?.[languageObj?.id]}: <b>${bankAccountLocal?.number}</b><br/>`,
                four: `${labels?.bank?.[languageObj?.id]}: <b>${description}</b><br/>`,
                five: `${messages?.thisProcessIrreversibleDoYouWishContinue?.[languageObj?.id]}`,
            };

            swalProperties = {
                icon: globalSettings?.react?.sweetAlert2?.icons?.warning,
                title: messages?.areYouSureDeleteThis?.[languageObj?.id],
                html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}${msgTextObj?.four}${msgTextObj?.five}`,
                timer: null,
                backdrop: true,
                confirmButtonColor: globalSettings?.colors?.warningColorExp,
                confirmButtonText: labels?.yes?.[languageObj?.id],
                showCancelButton: true, //!Swal.isLoading(), //true,
                cancelButtonColor: globalSettings?.colors?.successColorExp,
                cancelButtonText: labels?.no?.[languageObj?.id],
                showLoaderOnConfirm: true,
                didOpen: () => {
                    Swal.hideLoading();
                },
                preConfirm: async () => {
                    try {
                        Swal.getCancelButton().hidden = true;
                        Swal?.update({
                            icon: globalSettings?.react?.sweetAlert2?.icons?.info,
                            title: `${messages?.processing?.[languageObj?.id]}...`,
                            html: `${msgTextObj?.one}${msgTextObj?.two}${msgTextObj?.three}${msgTextObj?.four}`,
                            showConfirmButton: false,
                        });

                        //#region purchases delete
                        headerObj = {
                            headers: {
                                authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                                languageId: languageObj?.id,
                            },
                            url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBankAccounts}/${id}`,
                        };

                        result = await axios?.delete(
                            headerObj?.url,
                            headerObj,
                        );

                        response = result?.data;

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion purchase delete

                        //#region dtPurchases update
                        $(`#${dtBankAccountsId}`)?.DataTable()?.row(rowIndex)?.remove()?.draw(true);
                        //#endregion dtPurchases update

                        //#region buildingBalance calculate
                        response = await buildingBalanceGetAsync({
                            bankAccounts: [],
                            buildingId: buildingIdLocal,
                            subMethod: currentMethod,
                        });

                        if (!response?.isSuccess || response?.isWarning) {
                            await sendMessageCloseCurrentWindowAsync({
                                msgType: response?.msgType,
                                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                                closeWindow: false,
                                urlGoTo: response?.urlGoTo,
                                auth: auth,
                                isLogout: false,
                                languageId: languageObj?.id,
                                subMethod: currentMethod,
                            });
                            return;
                        }
                        //#endregion buildingBalance calculate

                        await sendMessageCloseCurrentWindowAsync({
                            msgType: 0,
                            msgText: `${messages?.processesCompletedSuccessfully?.[languageObj?.id]}.`,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                            subMethod: currentMethod,
                        });
                    } catch (ex) {
                        //#region Error
                        response.isSuccess = false;
                        response.msgType = -1;
                        response.msgText = `Method: ${currentMethod}<br/>`;
                        response.msgText += `Error: ${ex?.message}`;
                        await sendMessageCloseCurrentWindowAsync({
                            msgType: response?.msgType,
                            msgText: response?.msgText,
                            closeWindow: false,
                            urlGoTo: response?.urlGoTo,
                            auth: auth,
                            isLogout: false,
                            languageId: languageObj?.id,
                        });
                        //#endregion Error
                    }
                },
                allowOutsideClick: () => !Swal.isLoading(),
            };

            await Swal.fire(swalProperties);
            //#endregion show message
        } catch (ex) {
            setShowLoading({ building: false, bankAccounts: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const bankAccountMovementsAsync = async ({
        id = '',
        subMethod = '',
    }) => {
        const currentMethod = 'bankAccountMovementsAsync';
        let response = responseGet();
        try {
            setShowLoading({ building: false, bankAccounts: true, });
            await awaitDelay({ delayTimer: globalSettings?.timers?.oneSecond, });
            window.location.href = `${backend?.urlBankAccountMovements}/${id}`;
            setShowLoading({ building: false, bankAccounts: false, });
        } catch (ex) {
            setShowLoading({ building: false, bankAccounts: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }
    //#endregion bank account (methods)

    //#region coins (methods)
    const coinsGetAsync = async ({
        buildingId = '',
        subMethod = '',
    }) => {
        const currentMethod = 'coinsGetAsync';
        let response = responseGet();
        try {
            //#region variables
            //#endregion variables

            //#region variables initialize
            coinsTwo = [];
            setCoins([]);
            //#endregion variables initialize

            //#region coins get
            response = await validationCoinGetAsync({
                buildingId: buildingId,
                limit: 0,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            coinsTwo = response?.result || [];
            setCoins(coinsTwo);
            //#endregion coins get
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }
    //#endregion coins (methods)

    //#region banks (methods)
    const banksGetAsync = async ({
        buildingId = '',
        subMethod = '',
    }) => {
        let response = responseGet();
        try {
            //#region variables
            //#endregion variables

            //#region initialize
            banksTwo = [];
            setBanks([]);
            //#endregion initialize

            //#region banks get
            response = await validationBankGetAsync({
                buildingId: buildingId,
                limit: 0,
                auth: auth,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            banksTwo = response?.result || [];
            setBanks(banksTwo);
            //#endregion banks get
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }
    //#endregion banks (methods)

    //#region buildings (methods)
    const buildingBalanceGetAsync = async ({
        bankAccounts = [],
        buildingId = '',
        subMethod = '',
    }) => {
        const currentMethod = 'buildingBalanceGetAsync';
        let response = responseGet();
        try {
            //#region variables
            let buildingBalanceLocal = 0.00;
            let bankAccountsLocal = bankAccounts;
            //#endregion variables

            //#region data get (bank accounts)
            if (isUndNullEmp({ data: bankAccounts, subMethod: currentMethod, })?.result) {
                headerObj = {
                    headers: {
                        authorization: `bearer ${auth?.user?.tokenVzLaCondominios?.token}`,
                    },
                };

                dataObj = {
                    limit: 0,
                    ordersBy: [],
                    conditionals: [
                        { field: dbProps?.buildingId, operator: dbOpera?.equalTo, value: buildingId, },
                    ],
                    buildingId: buildingId,
                    languageId: languageObj?.id,
                    url: `${backend?.url}${backend?.urlApiV1}${backend?.urlBankAccounts}/`,
                };

                result = await axios?.post(
                    dataObj?.url,
                    dataObj,
                    headerObj,
                );

                response = result?.data || {};

                if (!response?.isSuccess || response?.isWarning) {
                    return response;
                }

                bankAccountsLocal = response?.result || [];
            }
            //#endregion data get (bank accounts)

            //#region methods
            if (!isUndNullEmp({ data: bankAccountsLocal, subMethod: currentMethod, })?.result) {
                buildingBalanceLocal = numberSet({
                    number: lodash?.sum({
                        data: bankAccountsLocal,
                        key: dbProps?.currentBalance,
                        consoleLogErrorShow: true,
                        subMethod: currentMethod,
                    })?.result,//sumBy(bankAccountsLocal, 'currentBalance'),
                    type: 'd',
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                })?.result;
            } else {
                buildingBalanceLocal = neutralValue;
            }

            headerSectionValues.levelOne.colThree.value = separatorsNumbersSet({
                number: buildingBalanceLocal,
                withDecimals: true,
                consoleLogErrorShow: true,
                subMethod: currentMethod,
            })?.result;
            setHeaderSectionValues(headerSectionValues);
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
        }
        return response;
    }
    //#endregion buildings (methods)

    //#region methods (others)
    const dataGetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataGetAsync';
        let response = responseGet();
        try {
            setShowLoading({ building: true, bankAccounts: true, });

            //#region initialize
            setBuildings([]);
            setBtnAddDisabled(true);
            //#endregion initialize

            //#region dataTables set
            response = await dataTablesSetAsync({
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, bankAccounts: false, });;
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }
            //#endregion dataTables set

            //#region data get (buildings)
            response = await buildingsByUserGetAsync({
                userRole: userRole,
                auth: auth,
                urlGoTo: backend?.urlBankAccounts,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                setShowLoading({ building: false, bankAccounts: false, });
                await sendMessageCloseCurrentWindowAsync({
                    msgType: response?.msgType,
                    msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                    closeWindow: false,
                    urlGoTo: response?.urlGoTo,
                    auth: auth,
                    isLogout: false,
                    languageId: languageObj?.id,
                    subMethod: currentMethod,
                });
                return;
            }

            if (!isUndNullEmp({ data: response?.result?.buildings, subMethod: currentMethod, })?.result && response?.result?.buildings?.length > 0) {
                setBuildings(response?.result?.buildings);
            }
            //#endregion data get (buildings)

            setShowLoading({ building: false, bankAccounts: false, });
        } catch (ex) {
            setShowLoading({ building: false, bankAccounts: false, });
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
    }

    const dataTablesSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesSetAsync';
        let response = responseGet();
        try {
            response = await dataTableBankAccountsSetAsync({
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }

            response = await queryCodeSetAsync({
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) {
                return response;
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const queryCodeSetAsync = async ({
        subMethod = '',
    }) => {
        const currentMethod = 'queryCodeSetAsync';
        let response = responseGet();
        try {
            //#region variables
            let id = '';
            let method = '';
            let rowIndex = 0;
            let dtRowIndex = 0;
            let description = '';
            //#endregion variables

            //#region bank accounts
            $(`#${dtBankAccountsId} tbody`)?.on('click', 'tr', 'td', function (e) {
                e?.preventDefault();
                rowIndex = $(`#${dtBankAccountsId}`)?.DataTable()?.row(this)?.index();
                dtRowIndex = !isUndNullEmp({ data: rowIndex, subMethod: currentMethod, })?.result ? rowIndex : dtRowIndex;
                if (!isUndNullEmp({ data: dtRowIndex, subMethod: currentMethod, })?.result) {
                    id = e?.target?.attributes?.id?.value;
                    method = e?.target?.attributes?.method?.value;
                    description = e?.target?.attributes?.description?.value;
                    switch (method) {
                        case 'details':
                            bankAccountsAddEditDetailsGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType_: 2, subMethod: currentMethod, });
                            break;
                        case 'edit':
                            bankAccountsAddEditDetailsGetAsync({ e: e, id: id, description: description, rowIndex: dtRowIndex, processType_: 1, subMethod: currentMethod, });
                            break;
                        case 'delete':
                            bankAccountDeleteAsync({ id: id, description: description, rowIndex: dtRowIndex, processType: -1, subMethod: currentMethod, });
                            break;
                        case 'movements':
                            bankAccountMovementsAsync({ id: id, subMethod: currentMethod, });
                            break;
                        default:
                            break;
                    }
                }
            });
            //#endregion bank accounts
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const dataTablesClearAsync = async ({
        bankAccouns = false,
        subMethod = '',
    }) => {
        const currentMethod = 'dataTablesClearAsync';
        let response = responseGet();
        try {
            if (bankAccouns) {
                $(`#${dtBankAccountsId}`)?.DataTable()?.rows()?.clear()?.draw(true);
            }
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}`;
            await sendMessageCloseCurrentWindowAsync({
                msgType: response?.msgType,
                msgText: !isUndNullEmp({ data: response?.msgHtml, subMethod: currentMethod, })?.result ? response?.msgHtml : response?.msgText,
                closeWindow: false,
                urlGoTo: response?.urlGoTo,
                auth: auth,
                isLogout: false,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });
        }
        return response;
    }

    const controlsStatusSet = ({ processType = 0, subMethod = '', }) => {
        let response = responseGet();
        const currentMethod = 'controlsStatusSet';
        try {
            //#region variables
            //#endregion variables

            //#region methods
            switch (processType) {
                case 0:
                    $(`#${controls?.dataTables?.bankAccounst?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.bankAccounst?.buttons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.bankAccounst?.spinners?.add?.id}`)?.removeClass();

                    $(`#${controls?.dataTables?.bankAccounst?.icons?.add?.id}`)?.addClass(controls?.dataTables?.bankAccounst?.icons?.add?.className);
                    $(`#${controls?.dataTables?.bankAccounst?.buttons?.add?.id}`)?.addClass(controls?.dataTables?.bankAccounst?.buttons?.add?.className);
                    $(`#${controls?.dataTables?.bankAccounst?.spinners?.add?.id}`)?.addClass(controls?.dataTables?.bankAccounst?.spinners?.add?.className);
                    break;
                case 1:
                    //$(`#${controls?.buttons?.add?.id}`)?.addClass(`${html?.button?.classes?.disabled} ${settings.react.html.button.classes.progress}`);
                    $(`#${controls?.dataTables?.bankAccounst?.icons?.add?.id}`)?.removeClass();
                    $(`#${controls?.dataTables?.bankAccounst?.spinners?.add?.id}`)?.addClass(`${html?.spinner?.borderSm}`);
                    break;
                default:
                    break;
            }

            //#region old code
            // $(`#${controls?.inputs?.email?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.inputs?.password?.id}`).attr('readOnly', (processType !== 0));
            // $(`#${controls?.checkBox?.remenberMe?.id}`).attr('disabled', (processType !== 0));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.forgotYourPassword?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlForgotPassword));
            // $(`#${controls?.urls?.userRegister?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlUserRegister));
            // $(`#${controls?.urls?.registerStatus?.id}`).attr('href', (processType !== 0 ? urlStop : backend?.urlRegisterStatus));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('href', (processType !== 0 ? urlStop : globalSettings?.react?.reCAPTCHA?.urlPrivaciConditions));
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr('target', (processType !== 0 ? '' : '_blank'));
            //#endregion old code

            //#region old code
            // $(`#${controls?.urls?.reCaptchaPrivaciConditions?.id}`).attr({
            //     'href': (processType !== 0 ? urlStop : globalSettings?.app?.reCAPTCHA?.urlPrivaciConditions),
            //     'target': (processType !== 0 ? '' : '_blank'),
            // });
            //#endregion old code

            //#region dataTable buttons
            // btnExcel.node.disabled = processType !== 0;
            // btnPdf.node.disabled = processType !== 0;
            //#endregion dataTable buttons

            $(`#${controls?.dataTables?.bankAccounst?.inputs?.search?.id}`)?.attr('readOnly', (processType !== 0));
            $(`#${controls?.dataTables?.bankAccounst?.selects?.entries?.id}`)?.attr('disabled', (processType !== 0));

            if (processType !== 0) {
                $(`#${controls?.dataTables?.bankAccounst?.buttons?.add?.id}`)?.addClass(`${html?.button?.classes?.disabled}`);
            }
            //#endregion methods
        } catch (ex) {
            response.msgType = -1;
            response.isSuccess = false;
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console?.error(response);
        }
        return response;
    }

    useEffect(() => {
        dataGetAsync({
            subMethod: 'form - onLoad',
        });
    }, [auth]) //eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods (others)

    return (
        <div>
            <Menu viewName='collection' process='collectionBankAccounts' />

            <div className='content-wrapper'>
                {/* Content Header (Page header) */}
                <section className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2'>
                            <div className='col-sm-6'>
                                <h6 className='m-0'>{labels?.bankAccounts?.[languageObj?.id]}</h6>
                            </div>{/* /.col */}
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right'>
                                    <li className='breadcrumb-item'><Link to='/'>{labels?.home?.[languageObj?.id]}</Link></li>
                                    <li className='breadcrumb-item active'>{labels?.bankAccounts?.[languageObj?.id]}</li>
                                </ol>
                            </div>{/* /.col */}
                        </div>{/* /.row */}
                    </div>{/* /.container-fluid */}
                </section>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>

                        <div className='row'>
                            <div className='col-12'>

                                {/*buildings*/}
                                <BuildingHeader buildingsId={buildingsId}
                                    building={building}
                                    buildings={buildings}
                                    btnSyncDisabled={btnBankAccountsSyncDisabled}
                                    methodGetAsync={bankAccountsGetAsync}
                                    processType={0}
                                    headerSectionValues={headerSectionValues}
                                    showLoading={showLoading?.building}
                                    languageObj={languageObj} />

                                {/*bank accounts*/}
                                <div className='card card-outline card-primary shadow-lg'>
                                    <LoadingSection alt='loadingSection'
                                        className={html?.overlay?.darkTextWhite}
                                        showText={true}
                                        text={globalSettings?.messages?.processing?.[languageObj?.id]}
                                        height={25}
                                        hidden={!showLoading?.bankAccounts}
                                        width={25}
                                        languageId={languageObj?.id}
                                        subMethod={currentMethod} />

                                    <div className='card-header'>
                                        <h6 className='card-title'>
                                            <img alt={labels?.bankAccounts?.[languageObj?.id]}
                                                style={styles?.cardHeaderLogo}
                                                src={globalSettings?.images?.bankAccountLogo}></img> - {labels?.bankAccounts?.[languageObj?.id]}
                                        </h6>

                                        <div className='card-tools'>
                                            <button type='button'
                                                className='btn btn-tool'
                                                data-card-widget='collapse'>
                                                <i className={icons?.minus}></i>
                                            </button>
                                            {/* <button tooltip='tooltip' title={labels?.add?.[languageObj?.id]} className='btn btn-outline-success float-right' onClick={()=> localElevatorAddGetAsync()}><i className={icons?.plusCircle}></i></button> */}
                                        </div>
                                    </div> {/*card header*/}

                                    <div className='card-body'>

                                        <div className='row'>
                                            {/* <div className='form-group text-right'>
                                                <button
                                                    className='btn btn-sm btn-outline-success'
                                                    disabled={isEmpty(building)}
                                                    onClick={(e) => bankAccountsAddEditDetailsGetAsync(e, '', '', 0, 0)}
                                                    tooltip='tooltip' title={labels?.add?.[languageObj?.id]}>
                                                    <i className={icons?.plusCircle}></i></button>
                                                <button
                                                    className='btn btn-sm btn-outline-danger mx-1'
                                                    disabled={isEmpty(building)}
                                                    hidden
                                                    id={btnBankAccountDeleteId}
                                                    onClick={(e) => localBankAccountDeleteGetAsync(e)}
                                                    tooltip='tooltip' title={labels?.delete?.[languageObj?.id]}>
                                                    <i className={icons?.trash}></i>
                                                </button>
                                            </div> */}
                                        </div>

                                        <div className='row'>
                                            {/* {!showLoading ? */}
                                            <div className='col-md-12'>
                                                {/* {showData ? */}
                                                {/* <div> */}
                                                <button id={controls?.dataTables?.bankAccounst?.buttons?.add?.id}
                                                    className={controls?.dataTables?.bankAccounst?.buttons?.add?.className}
                                                    disabled={isUndNullEmp({ data: building?.id, subMethod: currentMethod, })?.result || btnAddDisabled}
                                                    onClick={(e) => bankAccountsAddEditDetailsGetAsync({ e: e, id: '', description: '', rowIndex: 0, processType_: 0, subMethod: 'btn - bankAccountAdd', })}
                                                    tooltip='tooltip'
                                                    title={labels?.add?.[languageObj?.id]}>
                                                    <i id={controls?.dataTables?.bankAccounst?.icons?.add?.id} className={controls?.dataTables?.bankAccounst?.icons?.add?.className} /> <span id={controls?.dataTables?.bankAccounst?.spinners?.add?.id} className='' aria-hidden='true'></span>
                                                </button>
                                                {/* <button className='btn btn-sm btn-outline-danger float-right mx-1'
                                                    disabled={isUndefined(building) || isNull(building) || isEmpty(building) || btnAddDisabled}
                                                    hidden
                                                    id={btnBankAccountDeleteId}
                                                    onClick={(e) => localBankAccountDeleteGetAsync(e)}
                                                    tooltip='tooltip'
                                                    title={labels?.delete?.[languageObj?.id]}>
                                                    <i className={icons?.trash}></i>
                                                </button> */}

                                                <div className={globalSettings?.html?.dataTables?.formats?.tableResponsiveSm}>
                                                    <table id={dtBankAccountsId} className={globalSettings?.html?.dataTables?.formats?.smStripedBordered}></table>
                                                </div>
                                                {/* </div> */}
                                                {/* : */}
                                                {/* <></> */}
                                                {/* } */}
                                            </div>
                                            {/* : */}
                                            {/* <CssfxLoading type={globalSettings?.react?.CssfxLoading?.circularProgress}
                                                    width={40}
                                                    height={40}
                                                    color={globalSettings?.colors?.infoColorExp}
                                                    msgText={messages?.processing?.[languageObj?.id]}
                                                    msgOrientation='text-center'
                                                    msgTextMuted={true} /> */}
                                            {/* } */}
                                        </div>

                                    </div>
                                </div>

                            </div>{/*col*/}
                        </div>{/*row*/}

                    </div>{/* /.container-fluid */}
                </section>{/* /.content */}
            </div>

            {bankAccountShowModal ?
                <BankAccountAddEditDetails $={$}
                    auth={auth}
                    building={building}
                    buildingBalanceGetAsync={buildingBalanceGetAsync}
                    bankAccount={bankAccount}
                    setBankAccount={setBankAccount}
                    coins={coins}
                    banks={banks}
                    dtBankAccountsId={dtBankAccountsId}
                    dtRowIndex={dtBankAccountsRowIndex}
                    showModal={bankAccountShowModal}
                    setShowModal={setBankAccountShowModal}
                    processType={processType}
                    languageObj={languageObj} />
                :
                <></>
            }
        </div>
    )
}